import api from '@/shared/api/client';

/**
 * Appels clients qui ne rentrent ni dans le regime unitaire de la fiche, ni dans le
 * regime en masse.
 */

/**
 * Attribuer UN client a un agregateur, depuis la ligne du tableau.
 *
 * POURQUOI PAS `bulkUpdateClients([id], ...)`. C'est ce que faisait cet ecran, et le
 * chemin en masse exige `bulk:execute`, accorde au seul admin : le gestionnaire
 * reussissait la meme action depuis la fiche et prenait un 403 depuis la liste.
 *
 * La route exige `clients:write` ET `clients:agregateur`. La seconde est DELEGUEE :
 * un gestionnaire ne l'a que si son admin l'a ouverte (ecran « Droits delegues »).
 * Une chaine vide retire l'attribution -- c'est une decision commerciale, pas une
 * absence de saisie.
 */
export const changerAgregateur = (clientId, aggregateur) =>
  api.put(`/clients/${clientId}/agregateur`, { aggregateur }).then((r) => r.data);
